import { createContext, useContext, useState } from "react";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {

  const [permissions, setPermissions] = useState({});

  return (
    <PermissionContext.Provider
      value={{
        permissions,
        setPermissions,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);